import { render } from "./KtbBasicComponent.vue?vue&type=template&id=cb0f564a&scoped=true"
import script from "./KtbBasicComponent.vue?vue&type=script&lang=js"
export * from "./KtbBasicComponent.vue?vue&type=script&lang=js"

import "./KtbBasicComponent.vue?vue&type=style&index=0&id=cb0f564a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb0f564a"]])

export default __exports__